// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2sExf","title":"Header_title__2O5OG","side":"Header_side__tXA62"};